import { createSelector } from '@reduxjs/toolkit';

import { offerSelector } from './offer';

export const isIllegalConstructedSelector = createSelector(offerSelector, offer => offer.isIllegalConstruction);
